import Icon from '../Icon.vue'

Icon.register({
  'phone_number': {
    width: 14,
    height: 14,
    paths: [
      {
        d: 'M13.738 10.68l-2.317-2.33a.899.899 0 00-1.272-.001l-2.06 2.058-4.494-4.492 2.062-2.06a.899.899 0 00.001-1.27L3.339.263a.9.9 0 00-1.272 0L.004 2.325 0 2.322C0 8.772 5.231 14 11.684 14l2.053-2.05a.897.897 0 00.001-1.27z'
      }
    ]
  }
})
